import "./chunk-E5QRIS4Z.mjs";

// src/errors.ts
import {
  ClerkOfflineError,
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  isReverificationCancelledError,
  EmailLinkErrorCode,
  EmailLinkErrorCodeStatus
} from "@clerk/shared/error";
export {
  ClerkOfflineError,
  EmailLinkErrorCode,
  EmailLinkErrorCodeStatus,
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  isReverificationCancelledError
};
//# sourceMappingURL=errors.mjs.map